<div class="social-icons">
    <a href="https://www.linkedin.com/in/jesuseduaardo/">
        <i class="fab fa-linkedin fa-2x"></i>
    </a>
    <!-- <a href="https://github.com/jesuseduaardo">
        <i class="fab fa-github fa-2x"></i>
    </a> -->
</div>
<footer>&copy; Copyright {{ currentYear }}</footer>